import './polyfills';
import { scenePlugins } from '@ff-os/pdp-shared-registry/index';
import { giftPdpPlugin } from '@ff-scene-plugins/gift-pdp/giftPdpPlugin';
import { photoPrintsPdpPlugin } from '@ff-scene-plugins/photo-prints-pdp/photoPrintsPdpPlugin';
import { idtApi } from './idt/idtApi';

// Non-module style rules should always be the final import. This way, any overrides to
// `.idt-active` for example can be done at the component level, and made slightly more
// specific should this be desirable.
import './preflight.scss';
import './global.scss';

scenePlugins.use(giftPdpPlugin);
scenePlugins.use(photoPrintsPdpPlugin);

if (typeof window.__idt_hook === 'function') {
    window.__idt_hook(idtApi);
} else {
    window.IDT = idtApi;
}